module.exports = __webpack_public_path__ + "img/project_5.8f542c4c.png";